/* =========================================================
   CONFIGURACIÓN TOTE BAG (DESDE VERSIÓN KLAYVIO ROTA)
========================================================= */

const GIFT_PRODUCT_ID  = 9341932077299;
const GIFT_VARIANT_ID  = 48389671354611;
const GIFT_IMAGE_URL   = 'https://cdn.shopify.com/s/files/1/0657/7170/0467/files/Totebag.png?v=1767026731';

const GIFT_HEADER_TEXT = 'GIFT: REUSABLE TOTE BAG + FREE SHIPPING ON ALL ORDERS';
const GIFT_NOTE_TEXT   = '* Gift reusable tote bag is automatically added to your cart.';


/* =========================================================
   UTILIDADES
========================================================= */

function removeVariant(variantId){
  let updates = {};
  updates[variantId] = 0;
  jQuery.post('/cart/update.js', { updates });
}

function setVariantQty(variantId, qty){
  let updates = {};
  updates[variantId] = qty;
  jQuery.post('/cart/update.js', { updates });
}


/* =========================================================
   MENSAJE SIMPLE (SIN PROGRESS BAR)
========================================================= */

function renderGiftMessage(){
  if ($('.gift-message').length) return;

  $('.rebuy-cart__flyout-content').prepend(
    '<div class="gift-message" style="padding:16px;border-bottom:1px solid #eee;text-align:center;">' +
      '<p style="font-weight:600;margin-bottom:8px;">' + GIFT_HEADER_TEXT + '</p>' +
      '<img src="' + GIFT_IMAGE_URL + '" alt="Reusable Tote Bag" style="max-width:120px;margin:8px auto;" />' +
      '<p style="font-size:12px;opacity:.7;margin-top:8px;">' + GIFT_NOTE_TEXT + '</p>' +
    '</div>'
  );
}


/* =========================================================
   LÓGICA TOTE BAG (ANTI BUG / ANTI FRAUDE)
========================================================= */

function validateToteBag(cart){

  if (!cart || !cart.items) return;

  const items = cart.items;
  const totalPrice = cart.total_price;

  const toteItem = items.find(i => i.product_id === GIFT_PRODUCT_ID);

  const hasPaidProduct = items.some(
    i => i.product_id !== GIFT_PRODUCT_ID
  );

  /* -----------------------------------------
     1. NO permitir órdenes solo con tote
  ------------------------------------------ */
  if (!hasPaidProduct){
    if (toteItem){
      removeVariant(GIFT_VARIANT_ID);
    }
    return;
  }

  /* -----------------------------------------
     2. Máximo 1 tote por orden
  ------------------------------------------ */
  if (toteItem && toteItem.quantity > 1){
    setVariantQty(GIFT_VARIANT_ID, 1);
  }

  /* -----------------------------------------
     3. Asegurar tote si hay productos pagos
  ------------------------------------------ */
  if (!toteItem && totalPrice > 0){
    jQuery.post('/cart/add.js', {
      id: GIFT_VARIANT_ID,
      quantity: 1,
      properties: {
        "Gift": "Reusable tote bag"
      }
    });
  }
}


/* =========================================================
   DESTRABAR ADD TO CART (CRÍTICO)
========================================================= */

function restoreAddToCart(){
  $('body.template--product button.product-form--add-to-cart')
    .css('pointer-events','auto');

  $('body.template--product span.product-form--spinner').hide();
  $('body.template--product span.product-form--text').show();
}


/* =========================================================
   REBUY EVENTS (SEGUROS PARA MÉTRICAS)
========================================================= */

document.addEventListener('rebuy:smartcart.ready', function(event){
  const cart = event.detail.smartcart.cart;
  renderGiftMessage();
  validateToteBag(cart);
  restoreAddToCart();
});

document.addEventListener('rebuy:cart.change', function(event){
  const cart = event.detail.cart.cart;
  validateToteBag(cart);
});
